
export enum StatusMensagem {
  naoEnviada = 'naoEnviada',
  naoLida = 'naoLida',
  lida = 'lida',
}
